<div class="d-flex flex-column align-items-center py-2">
  <button class="btn-primary" mat-raised-button (click)="goToPage('doctor')">
    See a Doctor Now
  </button>
  <div class="hr-or"></div>
  <button color="primary" mat-raised-button>Schedule a Visit</button>
</div>
